import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import Loading from '../compnents/Loading';

const roleDashboardPaths = {
    admin: '/dashboard/admin',
    rm: '/dashboard/rm',
    compliance: '/dashboard/compliance',
    head: '/dashboard/head',
    portfolio_adviser: '/dashboard/portfolio',
    view_only: '/dashboard/view-only',
};

function DashboardHomeRedirect() {
    const { token, user, isAuthInitializing } = useContext(AuthContext);

    if (isAuthInitializing) {
        return <Loading />;
    }

    if (!(token && user)) {
        return <Navigate to="/login" replace />;
    }

    if (user.subscription === 'free') {
        return <Navigate to="/dashboard/demo" replace />;
    }

    return <Navigate to={roleDashboardPaths[user.role] || '/dashboard/admin'} replace />;
}

export default DashboardHomeRedirect;
